<template>
  <div class="choose-passion setMobileHeroNavigation">
    <template v-if="this.step === 1">
      <h1>Qual será a sua principal atividade?</h1>
      <div class="cards-area cards-area-desktop">
        <CheckboxCard
          v-for="(passion, index) in passions"
          :key="index"
          :name="passion.title" 
          :imageBackground="passion.image.src"
          :title="passion.displayName"
          @selectPassion="onSelectPassion"
          :passionSelected="passionSelected"
          :isPassion="true"
          :idAnalytics="passion.analytics"
          :priceScale="passion.priceScale"
        />

       
      </div>
      <div class="cards-area cards-area-mobile">
        <CarouselPassion
        :passionsCarousel="passions"
        :passionSelected="passionSelected"
        @clickSelectPassionCarousel="onSelectPassion"
        :isPassion="true"
        />
      </div>
    </template>
    <template v-if="this.step === 2">
      <h1 class="padding-left">O que você procura?</h1>
      <div class="cards-area largeContainer cards-area-desktop" v-if="this.innerWidth > 768">
        <CheckboxCard
          v-for="(feature, index) in this.featuresByPassionSelected"
          :key="index"
          :name="feature.name" 
          :imageBackground="feature.image"
          :title="feature.description"
          :description="feature.subDescription"
          @selectFeature="onSelectFeature"
          :featureSelected="featureSelected"
          :isPassion="false"
          :idAnalytics="feature.analytics"
          :priceScale="feature.priceScale"
        />
      </div>

      <div class="cards-area largeContainer cards-area-mobile">
        <CarouselFeature
          :featuresByPassionSelected="this.featuresByPassionSelected"
          @clickSelectFeatureCarousel="onSelectFeature"
          :featureSelected="featureSelected"
          />
      </div>
    </template>

    
  </div>
</template>

<script>

import passions from '../../constants/passions';
import CheckboxCard from '../CheckboxCard.vue';
import CarouselPassion from "./CarouselPassion.vue"
import CarouselFeature from "./CarouselFeature.vue"


export default {
  name: "ChooseYourPassion",
  components: { 
    CheckboxCard,
    CarouselPassion,
    CarouselFeature 
  },
  props: ["sendAnalytics", "step", "passionSelected", "featureSelected", "featuresByPassionSelected"],
  data() {
    return{
      passions,
      CheckboxCard,
      innerWidth: window.innerWidth
    }
  },
  computed: {},
  mounted() { },
  watch: {
    step() {
      document.querySelector('.cards-area').scrollTo(0, 0);
    }
  },
  methods: {
    onSelectPassion(selectPassion){
      this.$emit('clickSelectPassion', selectPassion);
    },
    onSelectFeature(selectFeature){
      this.$emit('clickSelectFeature', selectFeature);
    }
  },
};
</script>
<style lang="scss">
@import "../../sass/main.scss";

.choose-passion{
  display: flex;

  width: 100%;

  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  background-color: $color-gray;

  padding-left: 280px; // Sidebar

  min-height: 730px;

  h1{
    font-family: $font-family-title;
    font-size: 2.5rem;
    line-height: 3rem;

    margin: 0px 16px;

    text-align: center;

    // max-width: 700px;

    padding: 2% 0 0 0;
  }

  .cards-area{
    display: flex;
    justify-content: center;
    align-items: center;

    max-width: 1000px;

    flex-wrap: wrap;

    padding: 1.5rem 0 5% 0;
    gap: 1.5rem;
  }
  .cards-area.cards-area-mobile{
    display: none;
  }

  .largeContainer{
    max-width: 100%;
    padding: 1.5rem 0 6% 0;
  }
}

@media (max-width: 1410px){
  .choose-passion{
    .cards-area{
      padding-bottom: 8%;
    }

    .largeContainer{
      max-width: 1200px;
    }
  }
}

@media (max-width: 1166px) {
  .choose-passion{
    .cards-area{
      max-width: 800px;
    }
  }
}

@media (max-width: 900px) {
  .choose-passion{
    padding-bottom: 10%;
    .cards-area{
      max-width: 500px;
    }
  }
}

@media (max-width: $bp-mobile) {
  .choose-passion .cards-area.cards-area-mobile{
    display: block;
  }
  .choose-passion .cards-area.cards-area-desktop{
    display: none;
  }
  .choose-passion{
    padding: 20% 0 10% 0;

    min-height: 530px;
  
    h1{
      padding: 0;
      max-width: 500px;
      margin: 0 $margin-side-title-mobile;
      font-size: 2rem;
      line-height: 2.3rem;
    }

    .cards-area{
      flex-wrap: nowrap;
      justify-content: flex-start;
      max-width: 100%;
      -ms-overflow-style: none;  /* Internet Explorer 10+ */
      scrollbar-width: none;  /* Firefox */
      overflow: hidden;
    }

    .cards-area::-webkit-scrollbar { 
      display: none;  /* Safari and Chrome */
    }
    
  }
}

@media (max-width: 572px) {
  .choose-passion{
    padding: 25% 0 5% 0;

    h1{
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }
}

</style>